module.exports = __webpack_public_path__ + "img/master-card.fb9bc75e.svg";